import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yunjisuan",
  "use": "icon-yunjisuan-usage",
  "viewBox": "0 0 782.37 529.24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 782.37 529.24\" id=\"icon-yunjisuan\"><defs><style>#icon-yunjisuan .cls-1{fill:#999;}</style></defs><title>云计算</title><path class=\"cls-1\" d=\"M1038.37,503.17c0-107.52-87.5-195-195-195a196.51,196.51,0,0,0-23.15,1.48C792,226.93,713.26,169,624.17,169,510,169,417.07,261.87,417.07,376.09,328.24,376.09,256,448.36,256,537.17s72.24,161.07,161.07,161.07H854.28v-.56c102.42-5.73,184.08-90.67,184.08-194.51Zm-195,149.05H417.07a115.05,115.05,0,1,1,0-230.1h46v-46c0-88.8,72.25-161.07,161.07-161.07,67.92,0,128,43.39,150.88,105.7-73.93,27.73-126.78,98.94-126.78,182.44h46c0-82.15,66.87-149,149-149s149,66.83,149,149-66.87,149.05-149,149.05Zm0,0\" transform=\"translate(-256 -169)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yunjisuan.svg
// module id = EVE4
// module chunks = 19